/* ==============================================================================================
 * ISSUE DETAILS MODAL
 * ============================================================================================== */

var Sushi;
var CGS;

(function (Sushi, Plugins, CGS) {
	"use strict";

	var BasePlugin = Plugins.BasePlugin;
	var OffCanvas = Plugins.OffCanvas;
	var Events = Sushi.Events;

	var OptionDetail = function (triggerElement, options) {
		if (Sushi.getPluginInstance("OptionDetail", triggerElement)) {
			return;
		}

		this.element = triggerElement;

		BasePlugin.call(this, this.element, options);

		this.element.setAttribute("href", "#");
		this.element.setAttribute("data-off-canvas-content", "#optionDetailModal");
		this.element.setAttribute("data-off-canvas-position", "top right");
		this.element.setAttribute("data-off-canvas-from", "right");
		this.element.setAttribute("data-off-canvas-lock-scroll", "true");
		this.element.setAttribute("data-off-canvas-modifiers", "offCanvas medium");
		this.element.setAttribute("data-off-canvas-opens-from-hash", "false");
		this.element.setAttribute("data-off-canvas-close-on-overlay-click", "true");

		this.modal = new OffCanvas(this.element);

		Events(this.modal.element).on("Modal.open", this.handleModalOpen.bind(this));
		Events(this.modal.element).on("Modal.close", this.handleModalClose.bind(this));
	};

	OptionDetail.displayName = "OptionDetail";

	OptionDetail.prototype = Object.create(BasePlugin.prototype);

	var proto = OptionDetail.prototype;

	proto.constructor = OptionDetail;

	proto.handleAddToExportListClick = function (event) {
		this.onExportList = !this.onExportList;

		if (this.onExportList) {
			event.target.classList.add("on-export-list");
			event.target.innerText = "Remove from Export List";
		}
		else {
			event.target.classList.remove("on-export-list");
			event.target.innerText = "Add to Export List";
		}
	};

	proto.handleModalClose = function () {
		this.triggerElement.closest("tr").classList.remove("c-table__row--active");
	};

	proto.handleModalOpen = function () {
		this.triggerElement.closest("tr").classList.add("c-table__row--active");
		this.addToExportListButton = this.modal.element.querySelector("[data-feature=addToExportList]");

		if (this.addToExportListButton) {
			this.addToExportListButton.addEventListener("click", this.handleAddToExportListClick);
		}

		var cusipNumberElement = this.modal.element.querySelector("[data-cusip-number]");

		var cusipNumber = this.options.cusipNumber;

		cusipNumberElement.innerHTML = cusipNumber;

		// TODO: Update api endpoint URL
		var apiEndpoint = "/json/access/optionSearchResultsDetails.json";

		var tableElement = this.modal.element.querySelector("table");

		var columns = [
			{
				"data": "label",
				"className": "c-table__cell",
			},
			{
				"data": "value",
				"className": "c-table__cell",
			},
		];

		CGS.table(tableElement, {
			ajax: {
				url: apiEndpoint,
				dataSrc: function (json) {
					var data = [
						{
							label: "Option CUSIP",
							value: json.optionCusip,
						},
						{
							label: "Option ISIN",
							value: json.optionIsin,
						},
						{
							label: "OCC Code",
							value: json.optionOccCode,
						},
						{
							label: "OPRA Code",
							value: json.optionOpraCode,
						},
						{
							label: "Contract Name",
							value: json.optionContractName,
						},
						{
							label: "Underlying Symbol",
							value: json.optionUnderlyingSymbol,
						},
						{
							label: "CUSIP Issuer Name",
							value: json.optionIssuerName,
						},
						{
							label: "Underlying CUSIP",
							value: json.optionUnderlyingCusip,
						},
						{
							label: "Underlying ISIN",
							value: json.optionUnderlyingIsin,
						},
						{
							label: "Strike Price",
							value: json.optionStrikePrice,
						},
						{
							label: "Prompt Date",
							value: json.optionPromptDate,
						},
						{
							label: "Call/Put",
							value: json.optionCallPut,
						},
						{
							label: "Contract Start Date",
							value: json.optionContractStartDate,
						},
						{
							label: "Contract Exchanges",
							value: json.optionContractExchanges,
						},
						{
							label: "ISO CFI Code",
							value: json.optionIsoCfiCode,
						},
						{
							label: "US CFI Code",
							value: json.optionUsCfiCode,
						},
					];

					return data;
				},
			},
			columns: columns,
			columnDefs: [],
			paging: false,
			scrollY: "auto",
			dom: "<'_df _ttu _z10'<'_fxg'><'c-table__export _p0'B>>rt",
			initComplete: function (settings) {
				var scrollHead = settings.nScrollHead;
				var scrollBody = settings.nScrollBody;

				scrollHead.style.display = "none";
				scrollBody.style.overflow = "visible";
				scrollBody.classList.add("_pbxs", "_pb@laptop");
			},
			rowCallback: function (row, data) {
				row.classList.add("c-table__row--compact");

				if (data.type === "title") {
					row.classList.add("c-table__row--title");
				}
				else if (data.type === "empty") {
					row.classList.add("c-table__row--empty");
				}
			},
		});
	};

	Plugins.OptionDetail = OptionDetail;
})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}), CGS || (CGS = {}));
